document.addEventListener('DOMContentLoaded', initSwipers);
document.addEventListener('shopify:section:load', initSwipers);

function initSwipers() {
  document.querySelectorAll('.js-swiper').forEach((slider) => {
    if (slider.swiper) return;

    new Swiper(slider, {
      loop: slider.dataset.loop === 'true',

      speed: Number(slider.dataset.speed || 500),

      autoplay: slider.dataset.autoplay === 'true'
        ? {
            delay: Number(slider.dataset.delay || 5000),
            disableOnInteraction: false
          }
        : false,

      slidesPerView: Number(slider.dataset.mobile || 1),

      spaceBetween: Number(slider.dataset.space || 10),

      pagination: slider.querySelector('.swiper-pagination')
        ? {
            el: slider.querySelector('.swiper-pagination'),
            clickable: true
          }
        : false,

      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev')
      },

      breakpoints: {
        768: {
          slidesPerView: Number(slider.dataset.tablet || 2)
        },
        1200: {
          slidesPerView: Number(slider.dataset.desktop || 4)
        }
      }
    });
  });
}